import React from 'react';

type SingleFileStateProps = {
  file: File | null;
};

export const SingleFileState = ({ file }: SingleFileStateProps) => {
  // TODO: Dummy component, will be implemented in WHEEL-782
  // https://anchorfm.atlassian.net/browse/WHEEL-782
  return (
    <div>
      <div>Attached media: {file?.name}</div>
    </div>
  );
};
